import * as React from 'react';
import { connect } from 'react-redux';
import { ProgressBar } from 'react-bootstrap';
import { handlePreviousSalesStep, setStep } from '../../../actions/salesActions';
import PersonalInformation from '../PersonalInformation/PersonalInformation';
import CreditHistoryCheck from '../CreditHistoryCheck/CreditHistoryCheck';
import TravelByVehicle from './TravelByVehicle/TravelByVehicle';
import SelectVehicle from './SelectVehicle/SelectVehicle';
import { navigateTo } from '../../../actions/navigationActions';
import { GET_CODE_RED_INSURANCE } from '../../../routes/routes';
import CodeRedSearchVehicle from './CodeRedSearchVehicle/CodeRedSearchVehicle';

class CodeRedViewBuilder extends React.Component<any, any>  {
    constructor(props) {
        super(props);
        this.state = {
        };
        this.handleBack = this.handleBack.bind(this);
    }

    async handleBack() {
        if (this.props.sales.selectedSalesStep.step === 1
            || (this.props.sales.selectedSalesStep.step === 3 && this.props.sales.selectedSalesStep.subStep !== 2)) {
            await this.props.dispatchAction(navigateTo(GET_CODE_RED_INSURANCE))
        }
        else {
            await this.props.dispatchAction(handlePreviousSalesStep());
        }
    }

    public render() {
        return (
            <>
                <div className="pt-lg-5 p-lg-0 logged-in">
                    <div className="col-12 pb-4 text-lg-center text-md-center">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-10 col-md-12">
                                    <div className="row justify-content-center">
                                        <div className="col-2 col-md-3 col-lg-3 col-xl-2 pt-lg-2 text-center align-self-center">
                                            <div className="BackRectangle d-none d-lg-block d-md-block">
                                                <button onClick={this.handleBack} className="Back cursor-pointer"><img src="./images/OnlineQuotation/icon-back-button-desktop.png" alt="" /></button>
                                            </div>
                                            <div className="sidenav d-lg-none d-md-none" id="mySidenav">
                                                <button onClick={this.handleBack} className="Back cursor-pointer" id="about"><img src="./images/OnlineQuotation/icons-navigation-quote-back-btn.png" alt="" /></button>
                                            </div>
                                        </div>
                                        <div className="col-10 col-md-9 col-lg-9 col-xl-10 p-0 text-center align-self-center">
                                            <div>
                                                <ProgressBar variant="success" now={Math.trunc((this.props.sales.selectedSalesStep.step / this.props.sales.salesStepConfiguration.steps.length) * 100)} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-10 col-md-12 nopa">
                                    <div className="ssp-addportable-possessions-crown-icon mt-0px mb-20px mt-44px text-center">
                                        <div className="ssp-sales-journey-crown-icon" title="Add code red"></div>
                                    </div>
                                    {this.props.sales.selectedSalesStep.step === 1 &&
                                        <>
                                            <PersonalInformation />
                                        </>
                                    }
                                    {this.props.sales.selectedSalesStep.step === 2 &&
                                        <>
                                            <CreditHistoryCheck />
                                        </>
                                    }
                                    {this.props.sales.selectedSalesStep.step === 3 && this.props.sales.selectedSalesStep.subStep === 1 &&
                                        <>
                                            <TravelByVehicle />
                                        </>
                                    }
                                    {this.props.sales.selectedSalesStep.step === 3 && this.props.sales.selectedSalesStep.subStep === 2 &&
                                        <>
                                            <SelectVehicle />
                                        </>
                                    }
                                    {this.props.sales.selectedSalesStep.step === 4 &&
                                        <>
                                            <CodeRedSearchVehicle />
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        sales: state.sales
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(CodeRedViewBuilder)
